type Stack = { stackLabel: string; value: number };

type BarsWithTotals = {
  total: number;
  label: string;
  stacks: Stack[];
  comparison?: {
    total: number;
    stacks: Stack[];
  };
}[];

export const sortBarsWithTotals = (
  barsWithTotals: BarsWithTotals,
  sortBy: string,
) =>
  barsWithTotals.sort((a, b) => {
    if (sortBy === 'frequency') {
      const primarySort = b.total - a.total;
      if (primarySort !== 0) return primarySort;

      // In case of equal frequency,
      // sort by the absolute value of stacks ('Ranked first', 'Ranked second' or 'Ranked third').
      // Only check the next stack (e.g. 'Ranked second') if the previous one (e.g. 'Ranked first') is equal.
      for (let i = 0; i < a.stacks.length; i++) {
        const stackA = a.stacks[i];
        const stackB = b.stacks[i];
        const secondarySort = stackB.value - stackA.value;
        if (secondarySort !== 0) return secondarySort;
      }
      return 0;
    }

    const stackAbsoluteValue = (stacks: Stack[]) =>
      stacks.find((stack) => stack.stackLabel === sortBy)?.value ?? 0;

    return stackAbsoluteValue(b.stacks) - stackAbsoluteValue(a.stacks);
  });
